import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { OPTIONS } from "@/lib/onboardingOptions";
import ChipGrid from "./ChipGrid";

const transition = { duration: 0.5, ease: [0.22, 1, 0.36, 1] };

export default function Step3Geography({ draft, setDraft, next, prev }) {
  const set = (f) => (eOrV) =>
    setDraft((d) => ({
      ...d,
      [f]: eOrV?.target ? eOrV.target.value : eOrV,
    }));
  const canContinue = Boolean(draft.target_market);

  return (
    <motion.div
      data-testid="onboarding-step-3"
      key="step-3"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={transition}
      className="text-white"
    >
      <h2 className="text-[28px] font-extrabold leading-[1.1] tracking-tight md:text-[32px]">
        Where in the world?
      </h2>
      <p className="mt-2 text-[13px] text-white/55">
        Country is optional; market is required.
      </p>

      <div className="mt-6 space-y-6">
        <Group label="Which country are you based in?">
          <input
            data-testid="q-country-based"
            value={draft.country_based || ""}
            onChange={set("country_based")}
            placeholder="United States, India, UK, etc. (optional)"
            className="w-full rounded-xl border border-white/12 bg-white/5 px-3.5 py-2.5 text-[13px] text-white placeholder:text-white/35 focus:border-white/40 focus:outline-none"
          />
        </Group>

        <Group label="Where do you want to register the company?">
          <input
            data-testid="q-country-incorporation"
            value={draft.country_of_incorporation || ""}
            onChange={set("country_of_incorporation")}
            placeholder="Delaware (US), Estonia, Singapore, etc. (optional)"
            className="w-full rounded-xl border border-white/12 bg-white/5 px-3.5 py-2.5 text-[13px] text-white placeholder:text-white/35 focus:border-white/40 focus:outline-none"
          />
        </Group>

        <Group label="What market are you targeting first?">
          <ChipGrid
            testIdPrefix="q-target-market"
            options={OPTIONS.target_market}
            value={draft.target_market}
            onChange={set("target_market")}
            columns={2}
          />
        </Group>
      </div>

      <footer className="mt-8 flex items-center justify-between">
        <button
          type="button"
          data-testid="onboarding-step-back"
          onClick={prev}
          className="inline-flex items-center gap-1.5 text-[12.5px] font-semibold text-white/60 hover:text-white"
        >
          <ArrowLeft className="h-3.5 w-3.5" strokeWidth={2.4} />
          Back
        </button>
        <button
          type="button"
          data-testid="onboarding-step-continue"
          disabled={!canContinue}
          onClick={next}
          className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-[13px] font-bold text-black shadow-[0_10px_30px_-10px_rgba(255,255,255,0.5)] transition-opacity disabled:opacity-40"
        >
          Continue
          <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.6} />
        </button>
      </footer>
    </motion.div>
  );
}

function Group({ label, children }) {
  return (
    <div>
      <div className="eyebrow mb-2 text-white/55">{label}</div>
      {children}
    </div>
  );
}
